/// <amd-module name="VC/Markdown/Plugins/PathUtilities/VersionControlPathUrl" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */

/**
 * Combines a relativePath with a basePath and resolves all "../" path segements.
 */
export function resolveRelativePath(relativePath: string, basePath: string) {
    if (!relativePath) {
        relativePath = "";
    }

    if (!basePath) {
        basePath = "";
    }

    let encodedPath = uriEncodePathSegments(relativePath);
    let encodedBasePath = uriEncodePathSegments(basePath);

    let absUri = pathJoin(encodedBasePath, encodedPath);
    return decodeURIComponent(absUri);
}

/**
 * URI Encodes each segment in the path while preserving the '/' in between the segments or converting '\' to '/'
 */
function uriEncodePathSegments(path: string): string {
    let segments = path.split(/[\\\/]/);

    for (let i = 0; i < segments.length; i++) {
        segments[i] = encodeURIComponent(segments[i]);
    }
    return segments.join("/");
}

/**
 * Combines two paths together. Allows for resolution of relative paths with "../" in their path.
 * @param basePath Base path argument. This will have segments removed from the end when the relative path uses "../".
 * @param relativePath relative path attached to the base path. Allows for resolution of paths where "../" is included.
 */
function pathJoin(basePath: string, relativePath: string): string {
    let prepend = "";
    if (basePath.charAt(0) === "/") {
        basePath = basePath.slice(1);
        prepend = "/";
    }

    if (relativePath.charAt(0) === "/") {
        relativePath = relativePath.slice(1); // Array.join will take care of "/"'s in the path
    }

    let numberOfFilesInPath = 0;
    if (basePath.charAt(basePath.length - 1) === "/") {
        basePath = basePath.slice(0, basePath.length - 1);
    }
    else if (basePath.length > 0) {
        numberOfFilesInPath = 1;
    }

    let baseSegments = basePath.length ? basePath.split(/[\\\/]/) : []; // split will default to an array containing "", we dont want that.
    let relativeSegments = relativePath.split(/[\\\/]/);
    let up = true;
    let baseTraversals = 0;
    for (let i = 0; up && i < relativeSegments.length; i++) {
        if (relativeSegments[i] === ".") {
            relativeSegments.splice(i, 1);
            i--;
        }
        else if (relativeSegments[i] === "..") {
            baseTraversals++;
        } else {
            up = false;
        }
    }
    let base: string[] = [];
    if (baseTraversals < baseSegments.length) {
        base = baseSegments.slice(0, baseSegments.length - numberOfFilesInPath - baseTraversals);
    }

    const relative = relativeSegments.slice(baseTraversals)
    const resultSegments = base.concat(relative);
    const result = resultSegments.join("/");
    return prepend + result;
}
